import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { visuallyHidden as _visuallyHidden } from '@guardian/src-foundations/accessibility';
import { labelText, optionalText } from './styles';
const visuallyHidden = css `
	${_visuallyHidden}
`;
export const Text = ({ text, optional, hideLabel }) => (_jsxs("div", Object.assign({ css: (theme) => [
        labelText(theme.label && theme),
        hideLabel ? visuallyHidden : '',
    ] }, { children: [text, ' ', optional ? (_jsx("span", Object.assign({ css: (theme) => optionalText(theme.label && theme) }, { children: "Optional" }), void 0)) : ('')] }), void 0));
//# sourceMappingURL=Text.js.map
